/**
 * 🔒 The Possible duplicate question (decision 3014): before an upload's bytes
 * are sent, the window asks whether a file with the same content, or failing
 * that the same name, already sits on the record's company. The company itself,
 * its sites, its people and its documents are asked, within what the viewer may
 * read. A file already on the record itself is never offered, because the
 * same-name question of decision 2421 asks about the record's own files.
 */
export const FILE_DUPLICATES_PATH = '/files/duplicates';

/** 🔒 Use the existing file: one more record the file sits on, beside the one it is tagged to (decision 3014). */
export function fileLinksPath(fileId: string): string {
  return `/files/${encodeURIComponent(fileId)}/links`;
}

/** How the standing file matched: its content's hash, or failing that its name. */
export type FileDuplicateMatch = 'hash' | 'name';

/** The standing file the window draws beside the chosen one, with what it says above it. */
export interface PossibleDuplicate {
  id: string;
  filename: string;
  mimeType: string;
  fileTypeName: string;
  /** The record the file sits on, in words, such as *Company · Acme Controls*. */
  recordLabel: string;
  /** When its newest version was uploaded, an instant. */
  uploadedAt: string;
  /** Who uploaded its newest version. */
  uploadedByName: string | null;
  matchedBy: FileDuplicateMatch;
}

/**
 * The content hash the server stores for a version, so the browser asks with the
 * same digest: SHA-256 over the bytes, as lowercase hex.
 */
export function hexDigest(buffer: ArrayBuffer): string {
  return [...new Uint8Array(buffer)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
